<template lang="pug">
  .package-flow
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Code
        th Source
        th Sender
        th Transit
        th Reciever
        th Storage
        th Sender
        th Transit
        th Reciever
        th Destination
      tr(v-for="pf in packageFlow")
        td
          span.kzcode-default.clickable(@click="traceCode(pf.package.code)") {{pf.package.code}}
          div(v-if="pf.package") {{pf.package.packageType.name}}
          div.text-muted(v-if="pf.product") {{pf.product.name}}
        td
          FamFlag(v-if="pf.incoming && pf.incoming.location && pf.incoming.location.country.code" :code="pf.incoming.location.country.code")
          span.ml5(v-if="pf.incoming && pf.incoming.location") {{pf.incoming.location.name}}
        td
          span(v-if="pf.incoming && pf.incoming.sender") {{pf.incoming.sender.username}}
        td
          span(v-if="pf.incoming && pf.incoming.transitTime") {{pf.incoming.transitTime | elapsed}}
        td
          span(v-if="pf.incoming && pf.incoming.reciever") {{pf.incoming.reciever.username}}
        td
          span(v-if="pf.storageTime") {{pf.storageTime}}
        td
          span(v-if="pf.outgoing && pf.outgoing.sender") {{pf.outgoing.sender.username}}
        td
          span(v-if="pf.outgoing") {{pf.outgoing.transitTime | elapsed}}
        td
          span(v-if="pf.outgoing && pf.outgoing.reciever") {{pf.outgoing.reciever.username}}
        td
          FamFlag(v-if="pf.outgoing && pf.outgoing.location && pf.outgoing.location.country.code" :code="pf.outgoing.location.country.code")
          span.ml5(v-if="pf.outgoing && pf.outgoing.location") {{pf.outgoing.location.name}}
    IndefinitePagination(:fetch="fetchData")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import IndefinitePagination from '@/components/common/IndefinitePagination'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Page from '@/utils/common'
import { dateFilter, elapsedTime } from '@/filters/filters'
import FamFlag from '@/components/common/FamFlag'

export default {
  data: () => ({
    loading: false,
    packageFlow: null,
    pg: new Page({ page: 1, size: 15 }),
  }),
  methods: {
    fetchData(req) {
      this.loading = true
      return TrackNTrace.getLocationPackageFlow(this.locationId, req)
        .then((resp) => {
          this.packageFlow = resp.data.packageFlow
          this.loading = false
          return resp.data.hasMore
        })
        .catch((e) => { this.$emit('error', e) })
    },
    traceCode(code) {
      this.$router.push(`/trackntrace/dashboards/trace/${code}`)
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable,
    IndefinitePagination,
    FamFlag
  },
  filters: {
    date: dateFilter,
    elapsed: elapsedTime
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/PackageFlow.vue